// Memoization helper for performance optimization
const memoize = (fn) => {
  const cache = new Map();
  return (...args) => {
    const key = JSON.stringify(args);
    if (cache.has(key)) {
      return cache.get(key);
    }
    const result = fn(...args);
    cache.set(key, result);
    return result;
  };
};

/**
 * Formats a user's full name from a user object, handling missing fields
 * @param {Object} user - The user object
 * @returns {string} - Formatted full name or appropriate fallback text
 */
const _formatUserName = (user) => {
  if (!user) return 'Unassigned';
  
  // If name property exists, use it
  if (user.name) return user.name;
  
  // If firstName and/or lastName exist, combine them
  const firstName = user.firstName || '';
  const lastName = user.lastName || '';
  
  if (firstName || lastName) {
    return `${firstName} ${lastName}`.trim();
  }
  
  // Last resort: use email or id if available
  if (user.email) return user.email;
  if (user.id) return `User ${user.id}`;
  
  // If we have a user object but no identifiable info
  return 'Unknown user';
};

export const formatUserName = memoize(_formatUserName); 